/*
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-19 13:50:29
 * @LastEditors: guozhixion xiaoguo4072@163.com
 * @LastEditTime: 2022-06-13 11:57:49
 * @FilePath: /privacy-web/src/main.js
 */
import 'babel-polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import utils from './utils';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/base.css';
import './libs/px2rem';
import components from './components';
import 'element-ui/lib/theme-chalk/index.css';
import indexDB from './utils/indexDB/index';
import animated from 'animate.css';
// import VConsole from 'vconsole';
// let vConsole = new VConsole();
store.dispatch('mobile/checkMobile');
Vue.prototype.isMobile = store.state.mobile.isMobile;
window.isMobile = store.state.mobile.isMobile;
window.onresize = function () {
  store.dispatch('mobile/checkMobile');
  if (Vue.prototype.isMobile !== store.state.mobile.isMobile) location.reload();
};
Vue.config.productionTip = false;
(function () {
  let config = {
    mode: ['dig'], //digsa
    autosend: true, //pvuv,false
    digConfig: { autosend: true, target: '//dig.lianjia.com/bigc.gif' },
    saConfig: {
      // https://sensorsdata.cn/manual/js_sdk.html
      show_log: true,
      is_track_single_page: true,
      batch_send: true,
      is_single_page: true,
      server_url: process.env.VUE_APP_TRACKURL
    },
    domConfig: {
      //domfalse
      clickClass: 'CLICKDATA', //class
      clickEvtKey: 'data-click-evtid', //evtid dig
      clickEventKey: 'data-click-eventid', //event
      clickActionKey: 'data-action', //action
      viewClass: 'VIEWDATA', //class
      viewEvtKey: 'data-view-evtid', //evtid
      viewEventKey: 'data-view-eventid', //event
      viewActionKey: 'data-action' //action
    },
    globalData: {
      // pid: 'xxxx', //pid
      // h5pid: 'xxxx'
    }
  };
  window.my_track = new LIANJIA_TRACK(config);
})();

Vue.use(indexDB);
Vue.use(utils);
Vue.use(ElementUI);
Vue.use(components);
const IE11RouterFix = {
  methods: {
    hashChangeHandler() {
      this.$router.push(window.location.hash.substring(1, window.location.hash.length));
    },
    isIE11() {
      return !!window.MSInputMethodContext && !!document.documentMode;
    }
  },
  mounted() {
    if (this.isIE11()) {
      window.addEventListener('hashchange', this.hashChangeHandler);
    }
  },
  destroyed() {
    if (this.isIE11()) {
      window.removeEventListener('hashchange', this.hashChangeHandler);
    }
  }
};
new Vue({
  router,
  store,
  render(h) {
    // if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
    //   window.addEventListener('hashchange', () => {
    //     var currentPath = window.location.hash.slice(1)
    //     if (this.$route.path !== currentPath) {
    //       this.$router.push(currentPath)
    //     }
    //   }, false)
    // }
    return h(App);
  },
  mixins: [IE11RouterFix]
}).$mount("#app");

let images = [
  require('../src/assets/images/homePage/footer-img.png'),
  require('../src/assets/images/bj-01.png'),
  require('../src/assets/images/bj-02.png'),
  require('../src/assets/images/bj-03.png'),
  require('../src/assets/images/bj-04.png')
];
setTimeout(() => {
  images.forEach((item) => {
    let image = new Image();
    image.src = item;
    image.onload = () => {
    };
  });
}, 0);

